export default function Hero() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-transparent"
    >
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/95ea3a6b9baab5551419459f4fb45aca/8b8a1454b2e0b41416cfcbe2366cc8de.png')`
        }}
      />
      
      {/* White Overlay for Text Readability */}
      <div className="absolute inset-0 bg-white/70" />
      
      {/* Content */}
      <div className="container mx-auto px-6 text-center text-gray-900 relative z-10">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-6xl font-bold mb-6 leading-tight">
            From Vision to 
            <span className="text-[#0069a5]"> Reality</span>
          </h1>
          <p className="text-xl mb-8 text-gray-700 leading-relaxed">
            Discover the complete journey of 3D printed models - from initial concept and digital design 
            to precision printing and final masterpiece. Each model tells a story of innovation and craftsmanship.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-[#0069a5] hover:bg-[#005a8f] text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              Explore Models
            </button>
            <button className="border-2 border-[#0069a5] text-[#0069a5] hover:bg-[#0069a5] hover:text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
              View Process
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
